import { render, staticRenderFns } from "./RenderPhone.vue?vue&type=template&id=60b17c8c&"
import script from "./RenderPhone.vue?vue&type=script&lang=js&"
export * from "./RenderPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports